import { useCtraderOAuthCallbackMutation } from '@/service/ctrader/ctrader.hook';
import {
  createFileRoute,
  Navigate,
  useRouter,
  useSearch,
} from '@tanstack/react-router';
import { enqueueSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ImSpinner8 } from 'react-icons/im';
import z from 'zod';

const ctraderCallbackSchema = z.object({
  code: z.string().optional(),
});

// Module-level guard: prevents double-call from React StrictMode
let _submittedCode: string | null = null;

export const Route = createFileRoute('/_dashboard/dashboard/ctrader/')({
  component: RouteComponent,
  validateSearch: (params) => ctraderCallbackSchema.parse(params),
});

function RouteComponent() {
  const params = useSearch({ from: '/_dashboard/dashboard/ctrader/' });
  const router = useRouter();
  const { t } = useTranslation();
  const callbackMutation = useCtraderOAuthCallbackMutation({
    onSuccess() {
      enqueueSnackbar({
        variant: 'success',
        message: t('ctrader.dashboardSuccess'),
      });
      router.navigate({ to: '/dashboard/accounts', replace: true });
    },
    onError() {
      enqueueSnackbar({
        variant: 'error',
        message: t('ctrader.dashboardError'),
      });
      router.navigate({ to: '/dashboard/accounts', replace: true });
    },
  });

  useEffect(() => {
    if (params.code && _submittedCode !== params.code) {
      _submittedCode = params.code;
      callbackMutation.mutate({ code: params.code!, state: '' });
    }
  }, []);

  if (!params.code) return <Navigate to="/dashboard/accounts" replace />;

  return (
    <div className="m-auto page-container">
      <div className="mt-16 flex justify-center items-center flex-col">
        <h2 className="text-xl">{t('ctrader.dashboardConnecting')}</h2>
        <ImSpinner8 className="animate-spin mt-8 size-8" />
      </div>
    </div>
  );
}
